/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import { getFileIconComponent } from '../../../../shared/utils/attachmentUtils';
import {
  getAttachmentsTypesFromCombinedFile,
  specialDocumentTypes,
} from '../../../draft/attachments/services/constants';

export const getAttachmentsOfCategory = (submission, categoryDocumentTypes) => {
  if (submission?.attachments) {
    return submission.attachments?.filter(file => file.attachmentSubType === categoryDocumentTypes);
  }
  return [];
};

// creates a summary section for one attachments category
export const createAttachmentSection = (documents, category, categoryTitle, seeAllText, t, metaFields = []) => {
  const categoryCardData = {
    sectionHeader: categoryTitle,
    to: 'attachments',
    sectionIcon: documents?.length ? 'edit' : null,
    sectionLinkTo: documents?.length ? category : null,
  };
  categoryCardData.items = generateAttachmentItems(t, documents, category, seeAllText, metaFields);

  return categoryCardData;
};

// Generates max 2 attachment items with 'see all' link for the rest.
export const generateAttachmentItems = (t, documents, category, seeAllText, metaFields = [], divider = false) => {
  const attachmentItems = documents.map((document) => {
    return {
      title: generateTitle(document, t, metaFields),
      value: document.originalFileName,
      type: 'attachment',
      icon: getFileIconComponent(document),
      divider,
    };
  });

  return attachmentItems;
};

function generateTitle(document, t, metaFields = []) {
  let title =
    document.attachmentType === specialDocumentTypes.COMBINED
      ? `${t('attachments.type.COMBINED')} (${getAttachmentsTypesFromCombinedFile(document, t).join(', ')})`
      : t(`attachments.type.${document.attachmentType}`);
  metaFields.forEach((fieldName) => {
    if (document[fieldName]) {
      title = `${title} | ${document[fieldName]}`;
    }
  });
  return title;
}
